<template>
  <div>
    <v-container>
      <v-row
        v-if="
          (!this.currentUser.facebookToken &&
            !this.$store.state.loggedIntoFacebook) ||
          (this.currentUser.facebookToken &&
            !this.$store.state.loggedIntoFacebook)
        "
      >
        <v-col cols="12" class="text-center">
          <h2 class="compeatfont">Welcome to Compeat</h2>
          <p>Please sign in to Facebook</p>
          <v-btn
            small
            rounded
            @click="loginWithFacebook()"
            class="primary"
            :loading="facebookLoginLoading"
          >
            <v-icon>mdi-facebook</v-icon> Login To Facebook
          </v-btn>
          <p v-if="cancelledLogin">
            Client Cancelled Signin. please try again.
          </p>
        </v-col>
      </v-row>
      <generalAlert
        v-if="alert"
        :alert="alert"
        :alertType="alertType"
        :message="successResponse"
      />
      <v-row
        v-if="
          this.currentUser.facebookToken && this.$store.state.loggedIntoFacebook
        "
      >
        <v-col cols="12" sm="12" md="6" lg="6">
          <h2 class="compeatfont">Welcome {{ user.name }}</h2>
        </v-col>
        <v-col cols="6" class="text-right hidden-sm-and-down">
          <v-btn
            small
            rounded
            @click="logoutFromFacebook()"
            class="primary"
            :loading="facebookLoginLoading"
          >
            <v-icon>mdi-facebook</v-icon> Logout Facebook
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-tabs rounded v-model="tab" background-color="primary" dark>
            <v-tab :key="0"
              >My Demo Reports ({{ currentSalesPerson.length }})</v-tab
            >
            <v-tab :key="1"
              >Agency Demo Reports ({{ allDemoReports.length }})</v-tab
            >
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item :key="0">
              <v-card v-if="!overlay" flat class="py-3 px-3">
                <v-card-text class="pt-0">
                  <v-row justify="center" align="center">
                    <v-col cols="12" class="hidden-sm-and-down">
                      <h2 class="compeatfont">My Demo Reports</h2>
                    </v-col>
                    <v-col cols="12" class="hidden-md-and-up text-center">
                      <h2 class="compeatfont">My Demo Reports</h2>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-title class="pt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search Clients name, Company name or Date"
                    single-line
                    hide-details
                    class="pt-0"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <demoReport
                    @successAlert="successAlert"
                    :salesPeople="salesPeople"
                  />
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="currentSalesPerson"
                  :search="search"
                  :items-per-page="10"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn @click="viewDemoReport(item)" icon color="primary"
                      ><v-icon>mdi-eye</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </v-card>
              <v-skeleton-loader
                v-else
                height="372px"
                class="mx-auto"
                type="table-heading, table-thead, table-tbody, table-tfoot"
              >
              </v-skeleton-loader>
            </v-tab-item>

            <v-tab-item :key="1">
              <v-card v-if="!overlay" flat class="py-3 px-3">
                <v-card-text class="pt-0">
                  <v-row justify="center" align="center">
                    <v-col cols="12" class="hidden-sm-and-down">
                      <h2 class="compeatfont">Agency Demo Reports</h2>
                    </v-col>
                    <v-col cols="12" class="hidden-md-and-up text-center">
                      <h2 class="compeatfont">Agency Demo Reports</h2>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-title class="pt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search Clients name, Company name or Date"
                    single-line
                    hide-details
                    class="pt-0"
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="allDemoReports"
                  :search="search"
                  :items-per-page="10"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn @click="viewDemoReport(item)" icon color="primary"
                      ><v-icon>mdi-eye</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </v-card>
              <v-skeleton-loader
                v-else
                height="372px"
                class="mx-auto"
                type="table-heading, table-thead, table-tbody, table-tfoot"
              >
              </v-skeleton-loader>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import generalAlert from "@/components/alerts/generalAlert.vue";
import demoReport from "@/components/dialogs/demoReport.vue";
import { firebaseApp } from "../../firebaseConfig";
import {
  getFirestore,
  doc,
  getDoc,
  query,
  collection,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
const db = getFirestore(firebaseApp);

import moment from "moment-timezone";
export default {
  components: {
    demoReport,
    generalAlert,
  },
  props: ["uid", "user", "getcurrentuser"],
  data: () => ({
    //overlay loading
    overlay: false,

    //signed in user
    currentUser: [],
    userToken: "",
    currentSalesPerson: [],

    //facebook varibles
    facebookLoginLoading: false,
    cancelledLogin: false,

    //tab varibles
    tab: null,

    //agency varibles
    agencyProfile: [],

    //Demo reports varibles
    allDemoReports: [],

    // headers for table
    tableLoading: false,
    search: "",
    headers: [
      {
        text: "Client",
        value: "prospectingClientName",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Company",
        sortable: false,
        value: "packagePages[0].name",
        width: "15%",
        align: "center",
      },
      {
        text: "Email",
        sortable: false,
        value: "prospectingClientEmail",
        width: "15%",
        align: "center",
      },
      {
        text: "Date Created",
        value: "createdAt",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        width: "10%",
        align: "center",
      },
    ],
    //alert varibles
    successResponse: "",
    alertType: "",
    alert: false,

    //sales people for popup
    salesPeople: [],
  }),
  //Created Hook - gets the user and checks for facebook userToken
  created() {
    this.overlay = true;
    this.currentUser = this.$store.state.user;
    if (this.currentUser.facebookToken) {
      this.checkTokenValid(this.currentUser.facebookToken);
    } else {
      this.overlay = false;
    }
  },
  //facebook SDK
  mounted() {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      FB.init({
        appId: "736605293879783",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v16.0",
      });
    };
  },
  methods: {
    //Validates the user token
    checkTokenValid(token) {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const checkIfTokenIsValid = httpsCallable(
        functions,
        "checkIfTokenIsValid"
      );
      checkIfTokenIsValid({
        token: token,
      })
        .then((result) => {
          if (result.data.response.valid) {
            this.$store.commit("setloggedIntoFacebook", true);
            this.getAgencyInfo();
          }
        })
        .catch((err) => {
          this.$store.commit("setloggedIntoFacebook", false);
          this.overlay = false;
        });
    },
    //Logs user in with facebook SDK
    loginWithFacebook() {
      this.facebookLoginLoading = true;
      //incase user did cancel the login process
      this.cancelledLogin = false;
      FB.login(
        (response) => {
          if (response.authResponse) {
            this.userToken = response.authResponse.accessToken;
            this.extendUserFacebookToken();
          } else {
            this.cancelledLogin = true;
            this.overlay = false;
            console.log("Cancelled login or did not fully authorize");
          }
        },
        {
          scope:
            "read_insights, pages_show_list, ads_management, ads_read, page_events, pages_read_engagement, pages_read_user_content, public_profile, instagram_basic, instagram_manage_insights",
        }
      );
    },
    //Extends the userToken of client once logged in
    async extendUserFacebookToken() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const extendAccessToken = httpsCallable(functions, "extendAccessToken");

      extendAccessToken({
        token: this.userToken,
      }).then((result) => {
        this.updateUserFacebookToken(result.data.response);
      });
    },
    //Updates the user in firebase with the extended Token
    async updateUserFacebookToken(result) {
      const ref = doc(db, "users", this.currentUser.id);
      await updateDoc(ref, {
        facebookToken: result,
      });

      const ref2 = doc(db, "users", this.currentUser.id);
      const userUpdated = await getDoc(ref2);

      this.$store.commit("setUser", userUpdated.data());
      this.currentUser = userUpdated.data();

      this.facebookLoginLoading = false;
      this.checkTokenValid(this.currentUser.facebookToken);
    },
    //Logs out user using facebook SDK and clears the facebook userToken ine firebase
    logoutFromFacebook() {
      this.facebookLoginLoading = true;
      const functions = getFunctions(firebaseApp, "europe-west2");
      const facebookLogoutUser = httpsCallable(functions, "facebookLogoutUser");

      facebookLogoutUser({
        userId: this.currentUser.id,
      })
        .then((result) => {
          this.$store.commit("setloggedIntoFacebook", false);
          this.$store.commit("setUserFacebookToken", false);
          FB.getLoginStatus(function (response) {
            if (response.status === "connected") {
              var accessToken = response.authResponse.accessToken;
              FB.logout(
                function (response) {
                  console.log(response);
                },
                { access_token: accessToken }
              );
            }
          });
          this.facebookLoginLoading = false;
        })
        .catch((err) => {
          console.log("Error Signing user out", err);
          this.facebookLoginLoading = false;
        });
    },
    //Gets agency info if client has been cleared with facebook verification
    async getAgencyInfo() {
      try {
        const docRef = doc(db, "agencies", this.currentUser.agencyId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          this.agencyProfile = docSnap.data();
          this.$store.commit("setAgency", this.agencyProfile);
          this.getDemoReports();
        } else {
          console.log("No such document!");
          this.overlay = false;
        }
      } catch (err) {
        console.log("getAgencyInfo err", err);
        this.overlay = false;
      }
    },
    //gets all demo reports
    async getDemoReports() {
      this.tableLoading = true;
      let currentUsersDemos = [];
      let currentCompaniesDemos = [];

      const q = query(
        collection(db, "demoreports"),
        where("agencyId", "==", this.$store.state.agency.agencyId)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let report = doc.data();
        let createdMilliseconds = report.createdAt;
        let formatCreatedDate =
          moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
        report.createdAt = formatCreatedDate;

        if (
          report.agencyUser == this.$store.state.user.id ||
          report.salesPerson == this.$store.state.user.id
        ) {
          currentUsersDemos.push(report);
        } else {
          currentCompaniesDemos.push(report);
        }
      });
      this.currentSalesPerson = await this.sortUserArraysByDate(
        currentUsersDemos
      );
      this.allDemoReports = await this.sortUserArraysByDate(
        currentCompaniesDemos
      );

      this.getAgencySalesPeople();
    },
    //gets agency sales for demo popup
    async getAgencySalesPeople() {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          let user = doc.data();
          if (
            user.agencyId == this.$store.state.agency.agencyId &&
            user.userType == "AS"
          ) {
            this.salesPeople.push(user);
          }
          this.overlay = false;
          this.tableLoading = false;
        });
      } catch (err) {
        console.log("getAgencySalesPeople err", err);
      }
    },
    //sort by date
    sortUserArraysByDate(array) {
      array.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      return array;
    },
    //Alert functions to display response from adding new user
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;

      setTimeout(() => {
        this.getDemoReports();
        this.alert = false;
      }, 3000);
    },
    //View the demo report
    viewDemoReport(item) {
      this.$router.push({
        name: "demoReport",
        params: {
          reportId: item.reportId,
        },
      });
    },
  },
};
</script>
